import React from 'react';
import { FadeIn } from './FadeIn';
import { Leaf } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-brand-green text-white relative overflow-hidden" data-id="element-197">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-198"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-199">
        <FadeIn data-id="element-200">
          <div className="text-center mb-10" data-id="element-201">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 mb-6" data-id="element-202">
              <Leaf className="w-8 h-8 text-brand-orange" data-id="element-203" />
            </div>
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-204">
              El Protocolo de Sincronización Metabólica
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-205">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 text-lg md:text-xl leading-relaxed font-light" data-id="element-206">
            <p className="mb-6" data-id="element-207">
              En lugar de pelear contra tu cuerpo, vamos a darle las{' '}
              <strong className="text-brand-orange font-semibold" data-id="element-208">
                señales químicas correctas
              </strong>
              .
            </p>
            <p className="mb-6" data-id="element-209">
              Al ordenar tus comidas y tus movimientos de una manera específica,
              bajamos la insulina y el cortisol por voluntad propia.
            </p>
            <p className="text-2xl font-serif font-medium text-brand-cream border-l-4 border-brand-orange pl-6 my-8" data-id="element-210">
              Esto permite que tu cuerpo finalmente "suelte" la grasa acumulada
              y la use como energía real.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}